import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import ErrorAlert from '../ErrorAlert';

// Selectors
import { makeSelectError } from '../../services/error/selectors';
import { makeSelectInitialDataLoaded } from '../../services/initialDataLoaded/selectors';

interface Props {
    children: React.Node;
    error?: string;
    initialDataLoaded?: boolean;
    FallbackComponent?: React.Node;
    namespace: string;
    displayLogoutButton?: boolean;
}

/**
 * A component for only displaying an error if the initial data hasn't loaded
 */
export class InitialDataLoadedErrorGate extends React.PureComponent<Props> {
    render() {
        const {
            children,
            error,
            initialDataLoaded,
            FallbackComponent,
            namespace,
            displayLogoutButton
        } = this.props;
        if (error && !initialDataLoaded) {
            return (
                FallbackComponent || (
                    <ErrorAlert
                        namespace={namespace}
                        displayLogoutButton={displayLogoutButton}
                        isVisibleOnMount
                    />
                )
            );
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector({
    error: makeSelectError(),
    initialDataLoaded: makeSelectInitialDataLoaded()
});

export default connect(mapStateToProps)(InitialDataLoadedErrorGate);
